import React from "react";
import "./articles.css";


const GoverningCouncil = () => {

    return (
        <div className="main">
            <div className="art-container">
                <div className="about-header">
                    <h1>Governing Council</h1>
                </div>
                <div className="about-content-container">
                    <div className="overview-content">
                            <div className="about-sub-heading">
                                <h2>About the Governing Council-</h2>
                            </div>
                            <div className="article-text">
                                <p>
                                The <strong>Governing Council</strong> of the <strong>Girijananda Chowdhury University Alumni Association</strong> consists of distinguished professionals who work collaboratively to support the alumni network, organize events, and promote career and educational opportunities for students and graduates. The council's primary objectives include:
                                </p>
                                <ul>
                                    <li>Encouraging alumni to stay engaged with the university and contribute to its development.</li>
                                    <li>Organizing networking opportunities, reunions, and mentorship programs.</li>
                                    <li>Providing scholarships and financial aid to meritorious and underprivileged students.</li>
                                    <li>Strengthening university-industry relations by leveraging alumni connections.</li>
                                    <li>Supporting research initiatives and technological advancements at GCU.</li>
                                </ul>
                                <p>
                                The <strong>Girijananda Chowdhury University Alumni Association</strong> serves as a dynamic platform connecting former students across different professions and industries. This association nurtures lifelong relationships, fosters professional growth, and contributes to the development of the university and its students.
                                </p>
                            </div>
                        </div>
                </div>
                <div className="council-content-container">
                    <div className="council-content">
                        <div className="council-sub-heading">
                            <h2>Current Executive Committee (GCU Alumni Association)</h2>
                        </div>
                        <div className="article-text">
                            <p>The present <strong>Executive Committee</strong> comprises key office bearers who oversee and implement various alumni programs and initiatives.</p>
                            
                            <h3>Office Bearers</h3>
                            <ul>
                                <li>
                                    <strong>President</strong>: <strong>Dipankar Saha</strong> <em>(Registrar, Girijananda Chowdhury University)</em>
                                    <ul>
                                        <li>Leads the association's vision, ensures active alumni engagement, and fosters partnerships with industries and institutions.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Working President</strong>: <strong>Abhinandan Kalita</strong> <em>(Assistant Professor, GCU)</em>
                                    <ul>
                                        <li>Assists in implementing alumni initiatives and acts as the president in the absence of the primary office bearer.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Vice Presidents</strong>:
                                    <ul>
                                        <li><strong>Shrabani Medhi</strong> <em>(Assistant Professor, GCU)</em></li>
                                        <li><strong>Bishwadeep Poddar</strong> <em>(Deputy Manager, Industrial Revenue Collection, APDCL)</em></li>
                                        <li>Support the executive team by overseeing alumni engagement programs.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Secretary</strong>: <strong>Md Faruk Ahmed</strong> <em>(Assistant Professor, GCU)</em>
                                    <ul>
                                        <li>Manages correspondence, event coordination, and alumni outreach.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Treasurer</strong>: <strong>Trideep Saikia</strong> <em>(Assistant Professor, GCU)</em>
                                    <ul>
                                        <li>Maintains financial records, supervises fund allocation, and ensures financial sustainability.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Joint Secretaries</strong>:
                                    <ul>
                                        <li><strong>Subhadra Das</strong> <em>(Assistant Professor, GCU)</em></li>
                                        <li><strong>Ritisha Das</strong> <em>(Assistant Professor, GCU)</em></li>
                                        <li>Assist the Secretary in communication, documentation, and event planning.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Executive Members</strong>:
                                    <ul>
                                        <li><strong>Junumoni Das</strong> <em>(Assistant Professor, GCU)</em> -- Supports alumni activities and engagement.</li>
                                    </ul>
                                </li>
                            </ul>
                            <p>The <strong>Executive Committee</strong> plays a crucial role in ensuring the smooth functioning of the <strong>Alumni Association</strong>, acting as a bridge between the alumni community and the university.</p>
                        </div>
                    </div>
                </div>
                <div className="council-content-container">
                    <div className="council-content">
                        <div className="council-sub-heading">
                            <h2>Past Committee Members</h2>
                        </div>
                        <div className="article-text">
                            <p><strong>Previous Governing Body Members (GIPS Alumni Association)</strong></p>
                            <ul>
                                <li><strong>Dr. Gouranga Das</strong> -- Principal, GIPS</li>
                                <li><strong>Miss Madhuchandra Lahan</strong> -- Assistant Professor, GIPS</li>
                                <li><strong>Dr. Tapash Chakraborty</strong> -- Assistant Professor, GIPS</li>
                                <li><strong>Miss Tasrina Rahman</strong> -- Q.C. Officer, Azanta Pharma Ltd.</li>
                                <li><strong>Mr. Diganta Deka</strong> -- Q.A. Officer, Hetero Pharma</li>
                                <li><strong>Mr. Uttam Borah</strong> -- Railway Pharmacist</li>
                                <li><strong>Sheikh Sofiur Rahman</strong> -- Assistant Professor, GIPS</li>
                                <li><strong>Miss Ankita Kashyap</strong> -- Assistant Professor, GIPS</li>
                                <li><strong>Mr. Bikumani Malakar</strong> -- Production Manager, Azanta Pharma Ltd.</li>
                                <li><strong>Afsana Mehzabin</strong> -- M.Pharm Student, GIPS</li>
                                <li><strong>Mr. Sidhartha Jyoti Bora</strong> -- M.Pharm Student, GIPS</li>
                                <li><strong>Mr. Mustafizur Rahman</strong> -- M.Pharm Student, GIPS</li>
                                <li><strong>Mr. Anirnesh Hazarika</strong> -- Q.C. Chemist, Ozone Pharmaceuticals Ltd.</li>
                                <li><strong>Zahanur Rahman</strong> -- Hospital Pharmacist, Misamora Tea Garden</li>
                                <li><strong>Nurul Amin</strong> -- M.Pharm Student, GIPS</li>
                                <li><strong>Mazharul Islam Chowdhury</strong> -- Hospital Pharmacist, Azara Hospital</li>
                                <li><strong>Mr. Anupam Sanna</strong> -- Assistant Professor, PIPS</li>
                                <li><strong>Miss Asha Das</strong> -- Assistant Professor, GIPS</li>
                                <li><strong>Mr. Subrata Dutta</strong></li>
                            </ul>
                            <p>Each of these alumni has contributed to the institution in multiple ways—be it through mentorship, research collaborations, or student guidance.</p>
                        </div>
                    </div>
                </div>
                <div className="council-content-container">
                    <div className="council-content">
                        <div className="council-sub-heading">
                            <h2>Alumni Chapters of Girijananda Chowdhury University</h2>
                        </div>
                        <div className="article-text">
                            <p>To enhance alumni engagement and maintain a strong professional network, <strong>local and international alumni chapters</strong> have been formed in various regions. These chapters serve as platforms for:</p>
                            <ul>
                                <li>Encouraging regional alumni meet-ups and networking events.</li>
                                <li>Providing career guidance, mentorship, and industry exposure to current students.</li>
                                <li>Promoting professional collaboration among alumni.</li>
                                <li>Organizing social initiatives and outreach programs.</li>
                            </ul>
                            
                            <h3>Formation & Functioning of Alumni Chapters</h3>
                            <ul>
                                <li>
                                    <strong>Eligibility for Establishment</strong>:
                                    <ul>
                                        <li>Any city in <strong>India</strong> with at least <strong>20 alumni members</strong>.</li>
                                        <li>Any international location with at least <strong>5 alumni members</strong>.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Leadership & Management</strong>:
                                    <ul>
                                        <li>Each chapter elects a <strong>Chapter President</strong> and <strong>Chapter Secretary</strong> to oversee operations.</li>
                                        <li>A local <strong>Executive Committee</strong> is formed based on membership strength.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Financial Contributions</strong>:
                                    <ul>
                                        <li><strong>60% of funds</strong> raised by the local chapter are retained for its activities.</li>
                                        <li><strong>40% of funds</strong> are transferred to the <strong>Central Alumni Association Fund</strong>.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Accountability & Reporting</strong>:
                                    <ul>
                                        <li>The local chapter must <strong>submit annual financial reports</strong> to the central association.</li>
                                        <li>Any major event or initiative must be approved by the <strong>Central Executive Committee</strong>.</li>
                                        <li>A <strong>detailed member list and activity report</strong> should be submitted annually.</li>
                                    </ul>
                                </li>
                            </ul>
                            
                            <h3>Key Alumni Chapters & Locations</h3>
                            <ol>
                                <li><strong>Guwahati, Assam (Central Chapter)</strong> -- Headquarters of the alumni association.</li>
                            </ol>
                            <p>The alumni chapter provide a <strong>structured and interactive framework</strong> to enhance networking and collaborative opportunities for graduates across different regions.</p>
                        </div>
                    </div>
                </div>
                <div className="council-content-container">
                    <div className="council-content">
                        <div className="council-sub-heading">
                            <h2>Conclusion</h2>
                        </div>
                        <div className="article-text">
                            <p>The <strong>Girijananda Chowdhury University alumni association</strong> stand as a testament to the institution's commitment to fostering lifelong relationships with its graduates. With active governing bodies, well-structured alumni chapters, and a growing global network, the alumni association continues to:</p>
                            <ul>
                                <li>Strengthen <strong>university-alumni relationships</strong>.</li>
                                <li>Create a <strong>robust professional network</strong>.</li>
                                <li>Offer <strong>career and mentorship support</strong>.</li>
                                <li>Contribute to <strong>the overall growth of the institution and its students</strong>.</li>
                            </ul>
                            <p>The association invites all alumni to actively participate, engage in meaningful discussions, and contribute toward the development of <strong>GCU,</strong> ensuring a <strong>stronger future for students and graduates alike</strong>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GoverningCouncil;